import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FinanciacionPrivadaService } from './financiacion-privada.service';
import { AddFileService } from '../../../shared/components/add-file/add-file.service';
import { LocalDB } from '../../../shared/utils';
import { FinanciacionPrivadaModel } from './financiacion-privada.model';
import { AccountMovementsViewModel } from '../../accounting/models/accounting-movement.model';
import { consts } from '../../../consts';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';

@Component({
    selector: 'convfact-financiacionprivadaattachment',
    templateUrl: './financiacion-privada-dialog-attachment.component.html',
    styleUrls: ['./financiacion-dialogs.component.css'],
    standalone: false
})
export class FinanciacionPrivadaDialogAttachmentComponent {

  public uid: string;
  public descripcion: string;

  public originEntity: string = "Finanzas";
  public loadingFile = false;
  public errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<FinanciacionPrivadaDialogAttachmentComponent, boolean>,
    public financiacionPrivadaService: FinanciacionPrivadaService,
    private addFileService: AddFileService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notify: NotificationService,
  ) {
    this.uid = data.uid;
    this.descripcion = data.descripcion || '';
  }

  public uploadFile(event: any): void {
    const input = event.target as HTMLInputElement;
    const fileList: FileList = input.files;
    if (!fileList || fileList.length === 0 || this.loadingFile) return;

    const file: File = fileList[0];
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    this.errorMessage = '';
    this.setLoading(true);

    this.addFileService.attachFile(formData, this.originEntity)
      .then(response => {
        if (response.error) {
          throw { message: response.message };
        }

        LocalDB.RemoveForFiles();

        const fileUid = response.uid;

        const financiacionPrivada: FinanciacionPrivadaModel = {
          carencia: 0,
          bankAccountsUid: consts.EMPTY_GUID,
          accountingModelsCortoPlazoNumber: "",
          accountingModelsLargoPlazoNumber: "",
          descripcion: "",
          importeInicial: 0,
          importePendiente: 0,
          fechaConstitucion: new Date(),
          fechaFinalizacion: new Date(),
          plazo: 0,
          tipoInteres: 0,
          uid: this.uid,
          tipoLiquidaciones: 0,
          filesFinanciacionPrivadaUid: fileUid,
          duracion: 0,
          comisionApertura: 0,
          manualMovement: new AccountMovementsViewModel()
        };

        return this.financiacionPrivadaService.editFileAttachment(financiacionPrivada);
      })
      .then(result => {
        if (result !== true) {
          throw { message: 'No se ha podido adjuntar el fichero' };
        }
        this.setLoading(false);
        this.notify.ok('Se ha adjuntado el fichero correctamente');
        this.dialogRef.close(true);
      })
      .catch(error => {
        this.setLoading(false);
        input.value = '';
        this.errorMessage = (error && error.error && error.error.message) || (error && error.message) || 'No se ha podido adjuntar el fichero';
      });
  }

  public closeDialog(): void {
    if (this.loadingFile) return;
    this.dialogRef.close(false);
  }

  private setLoading(loading: boolean): void {
    this.loadingFile = loading;
    this.dialogRef.disableClose = loading;
  }
}
